export default "__VITE_ASSET__$5Q57a_I__"